import SharedErrorBoundary from '../../../../../shared/shared-error-boundary';
import GpanelContactsLabelsItem from './gpanel-contacts-labels-item';
import { useLocation, useNavigate } from 'react-router-dom';
import GpanelContactsLabelList from './gpanel-contacts-label-list';
import { Label } from '../../shared/types';
import { GPanelContactsPagesConfig } from '../../shared/pages-config';
import { useLabelGroupsQuery } from '../../gpanel-contacts-queries';
import { useGpanelContactsPermissions } from '../../shared/hooks/use-gpanel-contacts-permissions';
import { Messages } from '../../../../../utils/message-constants';

import Typography from '@mui/material/Typography';
import Divider from '@mui/material/Divider';
import Container from '@mui/material/Container';
import Business from '@mui/icons-material/Business';
import People from '@mui/icons-material/People';

export default function GpanelContactsLabels() {
  const { PERMISSIONS } = useGpanelContactsPermissions();
  const navigate = useNavigate();
  const location = useLocation();
  const { data, isLoading } = useLabelGroupsQuery();

  const pathSegments = location.pathname.split('/');
  const groupType = pathSegments[2];
  const selectedLabelId = pathSegments[3];

  const onLabelClick = (label: Label) => {
    navigate(
      `./${GPanelContactsPagesConfig.OrganizationLabels.link}/${label.id}`
    );
  };

  return (
    <>
      <Container
        sx={{
          '&': {
            p: 1,
            pr: 0,
          },
        }}
      >
        {typeof data?.myContactsCount === 'number' && (
          <GpanelContactsLabelsItem
            icon={<People />}
            label={GPanelContactsPagesConfig.MyContacts.name}
            count={data?.myContactsCount}
            selected={groupType === GPanelContactsPagesConfig.MyContacts.link}
            onClick={() =>
              navigate(`./${GPanelContactsPagesConfig.MyContacts.link}`)
            }
            isLoading={isLoading}
          />
        )}
        {typeof data?.organizationDirectoryCount === 'number' && (
          <GpanelContactsLabelsItem
            icon={<Business />}
            label={GPanelContactsPagesConfig.OrganizationDirectory.name}
            disabledReason={
              !PERMISSIONS.canViewGPanelContacts
                ? Messages.Errors.Permission.Viewing(
                    GPanelContactsPagesConfig.OrganizationDirectory
                      .requiredPermissionDisplayValue
                  )
                : ''
            }
            count={data?.organizationDirectoryCount}
            selected={
              groupType === GPanelContactsPagesConfig.OrganizationDirectory.link
            }
            disabled={!PERMISSIONS.canViewGPanelContacts}
            onClick={() =>
              navigate(
                `./${GPanelContactsPagesConfig.OrganizationDirectory.link}`
              )
            }
            isLoading={isLoading}
          />
        )}
      </Container>
      <Divider
        textAlign="left"
        sx={{
          '&.MuiDivider-root::before': {
            width: 0,
          },
        }}
      >
        <Typography variant="subtitle2">Labels</Typography>
      </Divider>
      <SharedErrorBoundary section="Directory - gPanel Contacts: Labels">
        <GpanelContactsLabelList
          labelGroups={data?.labelGroups}
          onLabelClick={onLabelClick}
          selectedLabelId={selectedLabelId ? Number(selectedLabelId) : Infinity}
          isLoading={isLoading}
        />
      </SharedErrorBoundary>
    </>
  );
}
